import React, { useState, useEffect } from 'react';
import { Form, Button, Alert, Spinner, Accordion, audio, Col, Row, Container, Table, InputGroup } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { postDataLogin, postData } from '../ApiServices/ApiService';
import NavHeader from './NavHeader';
import { CiSearch } from "react-icons/ci";
import { FaDownload } from 'react-icons/fa';
import { FaStop, FaMicrophone } from "react-icons/fa";
import { FaCircleCheck } from "react-icons/fa6";
import { IoMail } from "react-icons/io5";
import { GoXCircleFill } from "react-icons/go";
import { TbReportAnalytics } from "react-icons/tb";
import { IoIosCall } from "react-icons/io";
import { IoPersonCircle } from "react-icons/io5";
import ClipboardJS from 'clipboard';
import { BiLeftArrowAlt } from "react-icons/bi";
import { Skeleton } from '@mui/material';
import LoginNavLoginPage from './LoginNav_LoginPage';


const CandidateListsForManager = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const testID = searchParams.get('id');
  const verifyOtp = searchParams.get('verify');
  console.log("verifyOtp->", verifyOtp);

  const [candidateList, setCandidateList] = useState([]);
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [inputJobValue, setInputJobValue] = useState('')
  const aminInfo = JSON.parse(localStorage.getItem('ai-admin'));
  const [techDetails, setTechDetails] = useState();
  const [reportResponce, setReportResponce] = useState('');
  const [questionsResponce, setQuestionsResponce] = useState('');
  const [questionsLoading, setQuestionsLoading] = useState(false);
  const [questionsList, setQuestionsList] = useState([]);
  const [analysisList, setAnalysisList] = useState([]);
  const [pageLoader, setPageLoader] = useState(false);
  const [clientcategory,setClientCategory]=useState('TECHNOLOGY')


  useEffect(() => {
    const jobDetailsList = async () => {
      setCandidateList([])
      setQuestionsList([])
      setSuccess('');
      // const payload ={
      //   "company_id":aminInfo?.organization_id,
      //   "job_id": jobId,
      //   "user_id": aminInfo?.user_id
      // };console.log(payload);
      // setLoading(true)
      const payload = {
        "test_id": testID,
        //"test_id": "t_id_c_id_adm-8112817223101042045380104204538",
        "user_id": "1"
      }
      setPageLoader(true)
      try {
        await postDataLogin('admin_in/candidate-interview/get-interview-details_without_tkn', payload).then(resp => {
        //   resp.json().then(respData => {
            if (resp.statusCode === 200) {
            //   if (respData.statusCode === 200) {
                if (resp.message.toLowerCase() === 'success') {
                  console.log("resp.dataJ[0]", resp.dataJ[0]);
                  setCandidateList(resp.dataJ[0]);
                  setQuestionsList(resp.dataJ[0].questions)
                  // setAnalysisList(resp.dataJ[0].answer_analysis)
                  setPageLoader(false);
                  setLoading(false);
                  setClientCategory(resp.dataJ[0].client_category)
                  //setSuccess(resp.info);
                } else {
                  setLoading(false);
                  setPageLoader(false);
                  setSuccess(resp.info);
                }

            //   } else if (respData.statusCode === 500) {
            //     setLoading(false);
            //     setPageLoader(false);
            //     setSuccess(respData.info);
            //   } else {
            //     setLoading(false);
            //     setPageLoader(false);
            //     setSuccess('Job Details failed. Please check your credentials.');
            //   }
            }
            else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
              console.log('resp status else if : ', resp.status);
              setLoading(false);
              setPageLoader(false);
              setSuccess(resp.info);
            //   if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
            //     || respData.message === 'Access Denied') {
            //     setLoading(false);
            //     setPageLoader(false);
            //     //   callRefreshTokenApi('getSfeBatch', '');
            //   }
            //   setSuccess('Looks Like Session Expired Please login..');
            } else {
              console.log('resp status else  : ', resp);
              setLoading(false);
              setPageLoader(false);
              setSuccess(resp.info);
            }
          }).catch((error) => {
            setSuccess('Network Error');
            console.log('network error:', error);
            setLoading(false);
            setPageLoader(false);
          });
        // }).catch((error) => {
        //   setLoading(false);
        //   setPageLoader('JobDetails failed. Please check your credentials or Network Error');
        //   console.log('network error:', error);

        // });
      } catch (error) {
        setPageLoader(false);
        // Handle login error, e.g., display an error message to the user.
        console.error('Job Details failed', error);
      }
    }
    jobDetailsList();
  }, [])

  useEffect(() => {
    const getInterviewList = async () => {
      setAnalysisList([])
      setSuccess('');
      const payload = {
        "test_id": testID,
        "user_id": "1"
      }
      setLoading(true)
      try {
        await postDataLogin('admin_in/candidate-interview/get-interview-analysis_without_tkn', payload).then(resp => {
        //   resp.json().then(respData => {
            if (resp.statusCode === 200) {
            //   if (respData.statusCode === 200) {
                if (resp.message.toLowerCase() === 'success') {
                  console.log('resp status if  : ', resp.dataJ[0].answer_analysis);
                  setAnalysisList(resp.dataJ)
                  setLoading(false);
                  //setSuccess(resp.info);
                } else {
                  setLoading(false);
                  setSuccess(resp.info);
                }

            //   } else if (respData.statusCode === 500) {
            //     setLoading(false);
            //     setSuccess(respData.info);
            //   } else {
            //     setLoading(false);
            //     setSuccess('Interview Analysis Details failed. Please check your credentials.');
            //   }
            }
            else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
              console.log('resp status else if : ', resp.status);
              setLoading(false)
            //   if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
            //     || respData.message === 'Access Denied') {
            //     setLoading(false);
            //     //   callRefreshTokenApi('getSfeBatch', '');
            //   }
              setSuccess(resp.info);
            } else {
              console.log('resp status else  : ', resp);
              setLoading(false);
              setSuccess(resp.info);
            }
          }).catch((error) => {
            setSuccess('Network Error');
            console.log('network error:', error);
            setLoading(false);
          });
        // }).catch((error) => {
        //   setLoading(false);
        //   setSuccess("Network Error Please Try Again");
        //   console.log('network error:', error);

        // });
      } catch (error) {
        setLoading(false);
        // Handle login error, e.g., display an error message to the user.
        console.error('Interview Analysis failed', error);
      }
    }
    getInterviewList();
  }, [])

  const handleMicClick = () => {
    console.log('audio')
  }

  const generateAgainButton = () => {
    
    const payload = {
      "id": testID,
      "user_id": "1"
    }

    setQuestionsLoading(true)
    try {
      postData('admin_in/candidate-interview/gen-questions', payload).then(resp => {
        resp.json().then(respData => {
          if (resp.status === 200) {
            if (respData.statusCode === 200) {
              if (respData.message.toLowerCase() === 'success') {
                setTimeout(() => {
                  generateQuestions()
                }, 1000 * 30);
                setQuestionsResponce(respData.info)
              } else {
                setQuestionsResponce(respData.info)
                setQuestionsLoading(false)
              }

            } else if (respData.statusCode === 500) {
              setQuestionsResponce(respData.info)
              setQuestionsLoading(false)
            } else {
              setQuestionsLoading(false)
              setQuestionsResponce('Generate Questions failed. Please check your credentials.');
            }
          }
          else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
            console.log('resp status else if : ', resp.status);
            setLoading(false)
            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
              || respData.message === 'Access Denied') {
              setLoading(false);
              //   callRefreshTokenApi('getSfeBatch', '');
            }
            setSuccess('Looks Like Session Expired Please login..');
          } else {
            console.log('resp status else  : ', resp);
            setLoading(false);
          }
        }).catch((error) => {
          setQuestionsResponce('Network Error');
          
          setLoading(false);
        });
      }).catch((error) => {
        setQuestionsLoading(false)
        //setSuccess('JobDetails failed. Please check your credentials or Network Error');
        setQuestionsResponce('Generate Questions failed. Please check your credentials or Network Error.');
        

      });
    } catch (error) {
      setLoading(false);
      setQuestionsResponce('Generate Questions failed. Please check your credentials or Network Error!');
      // Handle login error, e.g., display an error message to the user.
      console.error('Job Details failed', error);
    }
  }

  // const [questionIntervel,setQuestionIntervel] = useState(null)
  const [questionIntervelCount, setQuestionIntervelCount] = useState(0)

  useEffect(() => {
    if (questionIntervelCount > 0 && questionIntervelCount < 3) {
     
      setTimeout(() => {
        generateQuestions()
      }, 1000 * 30);
    } else if (questionIntervelCount > 2) {
      setQuestionsLoading(false)
    } else {
     
    }
  }, [questionIntervelCount])

  const generateQuestions = () => {
    const payload = {
      "id": testID,
      "user_id": "1",
      "job_status": "LOOP"
    }
    //setLoading(true)
    try {
      postData('admin_in/candidate-interview/gen-questions', payload).then(resp => {
        resp.json().then(respData => {
          if (resp.status === 200) {
            if (respData.statusCode === 200) {
              if (respData.message.toLowerCase() === 'success') {
                if (respData.dataJ.length > 0) {
                  setQuestionsList(respData.dataJ)
                  setQuestionsResponce(respData.info)
                  setQuestionsLoading(false)
                } else {
                  setQuestionIntervelCount(prevCounter => prevCounter + 1);
                  setQuestionsResponce(resp.info)
                }
              } else {
                setQuestionsResponce(respData.info)
                setQuestionsLoading(false)
              }

            } else if (respData.statusCode === 500) {
              setQuestionsResponce(respData.info)
              setQuestionsLoading(false)
            } else {
              setQuestionsLoading(false)
              setQuestionsResponce('Generate Questions failed. Please check your credentials.');
            }
          }
          else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
            console.log('resp status else if : ', resp.status);
            setLoading(false)
            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
              || respData.message === 'Access Denied') {
              setLoading(false);
              //   callRefreshTokenApi('getSfeBatch', '');
            }
            setSuccess('Looks Like Session Expired Please login..');
          } else {
            console.log('resp status else  : ', resp);
            setLoading(false);
          }
        }).catch((error) => {
          setQuestionsResponce('Network Error');
          console.log('network error:', error);
          setLoading(false);
        });
      }).catch((error) => {
        setQuestionsLoading(false)
        //setSuccess('JobDetails failed. Please check your credentials or Network Error');
        setQuestionsResponce('Generate Questions failed. Please check your credentials or Network Error.');
        

      });
    } catch (error) {
      setQuestionsLoading(false)
      setQuestionsResponce('Generate Questions failed. Please check your credentials or Network Error!');
      // Handle login error, e.g., display an error message to the user.
      console.error('Job Details failed', error);
    }
  }

  const [isChecked, setIsChecked] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);
  const downloadAnalysisButton = () => {
    setReportResponce('')

    const payload = {
      "test_id": testID,
      "is_analysis": isChecked ? 1 : 0
    }
    setLoading(true)
    try {
      postData('admin_in/candidate-interview/download-analysis', payload).then(resp => {
        setLoading(false);
        resp.json().then(respData => {
          if (resp.status === 200) {
            if (respData.statusCode === 200) {
              if (respData.message.toLowerCase() === 'success') {
                setAudioUrl(respData.dataJ.audio_url)
                const analysisUrl = respData.dataJ.analysis_report_url
                // window.location.href = fileUrl;
                const link = document.createElement('a');
                link.href = analysisUrl;
                // link.download = 'Extraction Report.pdf';

                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);

              } else {
                setReportResponce(respData.info);
              }

            } else if (resp.statusCode === 500) {
              setReportResponce(respData.info);
            } else {
              setLoading(false);
              setReportResponce('Download Analysis failed. Please check your credentials.');
            }
          }
          else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
            console.log('resp status else if : ', resp.status);
            setLoading(false);
            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
              || respData.message === 'Access Denied') {
              setLoading(false);
              //   callRefreshTokenApi('getSfeBatch', '');
            }
            setSuccess('Looks Like Session Expired Please login..');
          } else {
            console.log('resp status else  : ', resp);
            setLoading(false);
          }
        }).catch((error) => {
          setReportResponce('Network Error');
          console.log('network error:', error);
          setLoading(false);
        });
      }).catch((error) => {
        setLoading(false);
        //setSuccess('JobDetails failed. Please check your credentials or Network Error');
        setReportResponce('Download Analysis failed. Please check your credentials or Network Error.');
        console.log('network error:', error);

      });
    } catch (error) {
      setLoading(false);
      setReportResponce('Download Analysis failed. Please check your credentials or Network Error!');
      // Handle login error, e.g., display an error message to the user.
      console.error('Job Details failed', error);
    }
  }

  const generateAnalysisButton = () => {
    setReportResponce('')
    
    const payload = {
      "id": testID
    }
    setLoading(true)
    try {
      postData('admin_in/candidate-interview/gen-analysis', payload).then(resp => {
        resp.json().then(respData => {
          if (resp.status === 200) {
            if (respData.statusCode === 200) {
              if (respData.message.toLowerCase() === 'success') {
                setReportResponce(respData.info);
                setTimeout(() => {
                  generateAnalysis()
                }, 1000 * 30);

              } else {
                setReportResponce(respData.info);
                setLoading(false);
              }

            } else if (respData.statusCode === 500) {
              setReportResponce(respData.info);
              setLoading(false);
            } else {
              setLoading(false);
              setReportResponce('Generate Analysis failed. Please check your credentials or Network Error!');
            }
          }
          else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
            console.log('resp status else if : ', resp.status);
            setLoading(false)
            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
              || respData.message === 'Access Denied') {
              setLoading(false);
              //   callRefreshTokenApi('getSfeBatch', '');
            }
            setSuccess('Looks Like Session Expired Please login..');
          } else {
            console.log('resp status else  : ', resp);
            setLoading(false);
          }
        }).catch((error) => {
          setReportResponce('Network Error');
          console.log('network error:', error);
          setLoading(false);
        });

      }).catch((error) => {
        setLoading(false);
        //setSuccess('JobDetails failed. Please check your credentials or Network Error');
        setReportResponce('Generate Analysis failed. Please check your credentials or Network Error!');
        console.log('network error:', error);

      });
    } catch (error) {
      setLoading(false);
      setReportResponce('Generate Analysis failed. Please check your credentials or Network Error!');
      // Handle login error, e.g., display an error message to the user.
      console.error('Job Details failed', error);
    }
  }

  const [analysisIntervelCount, setAnalysisIntervelCount] = useState(0)

  useEffect(() => {
    if (analysisIntervelCount > 0 && analysisIntervelCount < 6) {
      
      setTimeout(() => {
        generateAnalysis()
      }, 1000 * 30);
    } else if (analysisIntervelCount > 2) {
      setLoading(false)
    } else {
      
    }
  }, [analysisIntervelCount])

  const generateAnalysis = () => {
    const payload = {
      "id": testID,
      "job_status": "LOOP"
    }
    //setLoading(true)
    try {
      postData('admin_in/candidate-interview/gen-analysis', payload).then(resp => {
        resp.json().then(respData => {
          if (resp.status === 200) {
            if (respData.statusCode === 200) {
              if (respData.message.toLowerCase() === 'success') {
                if (respData.dataJ.length > 0) {
                  // setAnalysisList(resp.dataJ)
                  setReportResponce(respData.info)
                  setLoading(false)
                } else {
                  setAnalysisIntervelCount(prevCounter => prevCounter + 1);
                  setReportResponce(respData.info)
                }
              } else {
                setAnalysisIntervelCount(prevCounter => prevCounter + 1);
                setReportResponce(respData.info)
                // setLoading(false)
              }

            } else if (respData.statusCode === 500) {
              setReportResponce(respData.info)
              setLoading(false)
            } else {
              setLoading(false)
              setReportResponce('Generate Questions failed. Please check your credentials.');
            }
          }
          else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
            console.log('resp status else if : ', resp.status);
            setLoading(false)
            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
              || respData.message === 'Access Denied') {
              setLoading(false);
              //   callRefreshTokenApi('getSfeBatch', '');
            }
            setSuccess('Looks Like Session Expired Please login..');
          } else {
            console.log('resp status else  : ', resp);
            setLoading(false);
          }
        }).catch((error) => {
          setReportResponce('Network Error');
          console.log('network error:', error);
          setLoading(false);
        });
      }).catch((error) => {
        setLoading(false)
        //setSuccess('JobDetails failed. Please check your credentials or Network Error');
        setReportResponce('Generate Questions failed. Please check your credentials or Network Error.');
        console.log('network error:', error);

      });
    } catch (error) {
      setLoading(false)
      setReportResponce('Generate Questions failed. Please check your credentials or Network Error!');
      // Handle login error, e.g., display an error message to the user.
      console.error('Job Details failed', error);
    }
  }

  const [buttonText, setButtonText] = useState('Copy');

  const handleCopy = () => {
    const clipboard = new ClipboardJS('.copy-button', {
      text: function () {
        return candidateList?.exam_link;
      },
    });

    clipboard.on('success', () => {
      setButtonText('copied')
      clipboard.destroy();
    });

    clipboard.on('error', () => {
      alert('Failed to copy link to clipboard!');
      clipboard.destroy();
    });
  };

  const backButton =()=>{
    navigate(`/jobdetails?id=${candidateList?.job_id}&category=${clientcategory}`);
  }
let formattedDate;
const originalDateString = candidateList?.create_at?.substring(0, 10);

if (originalDateString) {
    const date = new Date(originalDateString);    
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    formattedDate = date.toLocaleDateString(undefined, {
      timeZone: userTimeZone,
      day: '2-digit',
      month: 'short', // 'short' will give you the abbreviated month name like 'Jun'
      year: 'numeric'
    }).replace(/,/g, '')
    .replace(/\s/g, '-');
}

const [downloading, setDownloading] = useState(false);
const [blobAudioUrl, setblobAudioUrl] = useState(null);

const convertAndPlayAudios = async (audioUrl) => {
  console.log("audioUrl",audioUrl);
  setDownloading(true);
  try {
    // Fetch the JSON file
    const response = await fetch(audioUrl);
    const data = await response.json();

    // Extract and decode the audio data
    const base64EncodedAudioData = data.audio_data;
    const decodedAudioData = atob(base64EncodedAudioData);

    // Convert to binary array
    const audioArrayBuffer = new Uint8Array(decodedAudioData.length);
    for (let i = 0; i < decodedAudioData.length; i++) {
      audioArrayBuffer[i] = decodedAudioData.charCodeAt(i);
    }

    // Create a Blob and URL for the audio data
    const audioBlob = new Blob([audioArrayBuffer], { type: 'audio/mpeg' });
    const url = URL.createObjectURL(audioBlob);
    
    

    // Play the audio
    const audioElement = new Audio(url);
    setblobAudioUrl(url);
    setDownloading(false);
    console.log("blobAudioUrl",blobAudioUrl);
    // audioElement.play();
  } catch (error) {
    console.error('Error converting audio:', error);
  }
};

const [indexing, setindexing] = useState(null);
const [error, seterror] = useState('');
const convertAndPlayAudio = async (audioUrl, index) => {
  seterror("");
  setblobAudioUrl('');
  if(!audioUrl){
    seterror("Audio Data Is Not Available");
  }
  console.log("audioUrl", audioUrl);
  setDownloading(true);
  // setLoading(true);
  setindexing(index);
  try {
    // Fetch the JSON file
    const response = await fetch(audioUrl);
    if (!response.ok) {
      seterror('Audio Data Is Not Available');
      setDownloading(true);
      setblobAudioUrl('');
      return
    }
    const data = await response.json();

    // Extract and decode the audio data
    const base64EncodedAudioData = data.audio_data;
    const decodedAudioData = atob(base64EncodedAudioData);

    // Convert to binary array
    const audioArrayBuffer = new Uint8Array(decodedAudioData.length);
    for (let i = 0; i < decodedAudioData.length; i++) {
      audioArrayBuffer[i] = decodedAudioData.charCodeAt(i);
    }

    // Create a Blob and URL for the audio data
    const audioBlob = new Blob([audioArrayBuffer], { type: 'audio/mpeg' });
    const url = URL.createObjectURL(audioBlob);
    setblobAudioUrl(url);

    // Update the analysisList state with the new blobAudioUrl
    setAnalysisList(prevState => {
      const updatedList = [...prevState];
      updatedList[index] = { ...updatedList[index], blobAudioUrl: url };
      return updatedList;
    });

    setDownloading(false);
    // setLoading(false);
    console.log("blobAudioUrl", url);
  } catch (error) {
    console.error('Error converting audio:', error);
    setDownloading(false);
    setblobAudioUrl('');
  }
  finally {
    setDownloading(false);
    setblobAudioUrl('');
    // setLoading(false);
  }
};
const [indexing1, setindexing1] = useState(null);
const [blobVideoUrl, setBlobVideoUrl] = useState(null);
const playVideoFromPresignedUrl = async (url, index) => {
  seterror("");
  setindexing1(index)
  setDownloading(true);

  try {
    if (!url) {
      throw new Error("Video Data Is Not Available");
    }

    // Fetch the blob content from the pre-signed URL
    const response = await fetch(url);
    const blob = await response.blob();

    // Create an object URL for the blob
    const objectURL = URL.createObjectURL(blob);
    console.log("objectURL", objectURL);

    setBlobVideoUrl(objectURL);

    setAnalysisList(prevState => {
      const updatedList = [...prevState];
      updatedList[index] = { ...updatedList[index], blobVideoUrl: objectURL };
      return updatedList;
    });

    setDownloading(false);


  } catch (error) {
    console.error('Error converting video:', error);
    seterror(error.message);
    setDownloading(false);
    setBlobVideoUrl('');
  } finally {
    setDownloading(false);
    setBlobVideoUrl('');
  }
};

const [emailInput, setEmailInput] = useState('');
const [otpInput, setOtpInput] = useState('');
const [showOtp, setShowOtp] = useState(false);

  const handleChange = (event) => {
    setEmailInput(event.target.value);
  };

  const handleOTPChange = (event) => {
    setOtpInput(event.target.value);
  };

  const [sendEmail, setSendEmail] = useState(false);
  const [emailSuccess, setEmailSuccess] = useState('');
  const handleSendMail = () => {
    setLoading(true);
    setSendEmail(true);
    setSuccess('');
    setEmailSuccess('');
    const emails = emailInput.split(',').map(email => email.trim());
    const popupLink = `${window.location.href}&verify=true`;
    if(!emailInput){
      setLoading(false)
      setSendEmail(false);
      setSuccess("Please Enter Email");
      return
    }
    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(emailInput)) {
      setLoading(false);
      setSendEmail(false);
      setSuccess("Please Enter a Valid Email");
      return;
    }
    const payload = {
      "op": "send_analysis_to_manager_otp",
      "manager_emails": emails,
      "test_id": testID,
      "candidates_link": popupLink
    }
    console.log("payload->", payload);
    // return
    //setLoading(true)
    try {
      postData('admin_in/send_verify_manager_otp/send_analysis_to_manager_otp', payload).then(resp => {
        resp.json().then(respData => {
          if (resp.status === 200) {
            if (respData.statusCode === 200) {
              if (respData.message.toLowerCase() === 'success') {
                setEmailInput('');
                setShowOtp(true);
                setLoading(false)
                setSendEmail(false);
                // setSuccess(respData.info);
                setEmailSuccess(respData.info);
              } else {
                setLoading(false)
                setSendEmail(false);
                setSuccess(respData.info);
                // setAnalysisIntervelCount(prevCounter => prevCounter + 1);
                // setReportResponce(respData.info)
                // setLoading(false)
              }

            } else if (respData.statusCode === 500) {
              // setReportResponce(respData.info)
              setLoading(false)
              setSendEmail(false);
              setSuccess(respData.info);
            } else {
              setLoading(false)
              setSendEmail(false);
              // setSuccess(respData.info);
              setSuccess('Email Sent failed. Please check your credentials.');
            }
          }
          else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
            console.log('resp status else if : ', resp.status);
            setLoading(false)
            setSendEmail(false);
            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
              || respData.message === 'Access Denied') {
              setLoading(false);
              setSendEmail(false);
              //   callRefreshTokenApi('getSfeBatch', '');
            }
            setSuccess('Looks Like Session Expired Please login..');
          } else {
            console.log('resp status else  : ', resp);
            setLoading(false);
            setSendEmail(false);
          }
        }).catch((error) => {
          // setReportResponce('Network Error');
          console.log('network error:', error);
          setLoading(false);
          setSendEmail(false);
        });
      }).catch((error) => {
        setLoading(false)
        setSendEmail(false);
        //setSuccess('JobDetails failed. Please check your credentials or Network Error');
        setSuccess('Email Sent failed. Please check your credentials.');
        console.log('network error:', error);

      });
    } catch (error) {
      setLoading(false)
      setSendEmail(false);
      setSuccess('Email Sent failed. Please check your credentials.');
      // Handle login error, e.g., display an error message to the user.
      console.error('Job Details failed', error);
    }
  };


  const handleOtpVerfication = () => {
    setLoading(true);
    setSendEmail(true);
    setSuccess('')
    if(!otpInput){
      setLoading(false)
      setSendEmail(false);
      setSuccess("Please Enter OTP");
      return
    }
    const payload = {
      "op": "verify_analysis_to_manager_otp",
      "manager_otp": otpInput,
      "test_id": testID,
    }
    console.log("otppayload->", payload);
    // return
    //setLoading(true)
    try {
      postDataLogin('admin_in/send_verify_manager_otp/verify_analysis_to_manager_otp', payload).then(resp => {
        // resp.json().then(respData => {
          if (resp.statusCode === 200) {
            // if (respData.statusCode === 200) {
              if (resp.message.toLowerCase() === 'success') {
                setOtpInput('');
                setShowPopup(false)
                setLoading(false)
                setSendEmail(false);
                // setSuccess(respData.info)
              } else {
                setLoading(false)
                setSendEmail(false);
                setSuccess(resp.info)
                // setAnalysisIntervelCount(prevCounter => prevCounter + 1);
                // setReportResponce(respData.info)
                // setLoading(false)
              }

            // } else if (respData.statusCode === 500) {
            //   // setReportResponce(respData.info)
            //   setLoading(false)
            //   setSendEmail(false);
            //   setSuccess(respData.info)
            // } else {
            //   setLoading(false)
            //   setSendEmail(false);
            //   setSuccess('Email Send failed. Please check your credentials.');
            // }
          }
          else if (resp.statusCode === 500) {
            console.log('resp status else if : ', resp.status);
            setLoading(false)
            setSendEmail(false);
            setSuccess(resp.info);
          } else {
            console.log('resp status else  : ', resp);
            setLoading(false);
            setSendEmail(false);
          }
        // }).catch((error) => {
        //   // setReportResponce('Network Error');
        //   console.log('network error:', error);
        //   setLoading(false);
        //   setSendEmail(false);
        // });
      }).catch((error) => {
        setLoading(false)
        setSendEmail(false);
        //setSuccess('JobDetails failed. Please check your credentials or Network Error');
        setSuccess('Verification failed. Please check your credentials.');
        console.log('network error:', error);

      });
    } catch (error) {
      setLoading(false)
      setSendEmail(false);
      setSuccess('Verification failed. Please check your credentials.');
      // Handle login error, e.g., display an error message to the user.
      console.error('Job Details failed', error);
    }
  };

  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if(verifyOtp != null || verifyOtp != undefined){
      setShowPopup(true)
    }
  }, []);



  return (
    <div className='dashboard-div ' style={{ overflowX: 'hidden' }}>
      
      { verifyOtp != null && <LoginNavLoginPage></LoginNavLoginPage>}
      {verifyOtp === null && <NavHeader ></NavHeader>}
      {success && <div className='error-msg'> {success}  </div>}
      {(!showPopup && <div style={{ overflowX: 'hidden', width: '100%' }} >
        <div className='candidate-title'> Candidate Information</div>

        {/* <h5 style={{ paddingLeft: '25px', paddingTop: '25px' }}>Personal Details :</h5> */}
        {pageLoader && (
          <div className="spinner-overlay" style={{ zIndex: 999 }}>
            <Spinner animation="border" role="status">
              <span className="sr-only"></span>
            </Spinner>
          </div>
        )}
        {/* {candidateList  &&( */}
        <div className='div-width'>
        {/* { verifyOtp === null &&<BiLeftArrowAlt  style={{fontSize:'30px',cursor:'pointer'}} onClick={backButton}/>} */}
          <Row className='info-div'>
            <Col>
              <div >
                <div ><span className='info-title'>Name <IoPersonCircle className='marg-btm-4' /> :</span><span className='info-data' style={{ textTransform: 'capitalize' }}> {candidateList?.candidate_name}</span></div>
                <div ><span className='info-title'>Email <IoMail className='marg-btm-4' />:</span><span className='info-data'> {candidateList?.candidate_email}</span></div>
                {candidateList?.phone_number?.length > 0 &&(<div ><span className='info-title'>Phone Number   <IoIosCall className='marg-btm-4' />:</span><span className='info-data'> {candidateList?.country_code}{candidateList?.phone_number}</span></div>)}
                <div > <span className='info-title'>Job Id:</span> <span className='info-data'> {candidateList?.job_id}</span></div>
                {candidateList?.technologies_str && <div ><span className='info-title'>Skills:</span><span className='info-data'> {candidateList?.technologies_str}</span></div>}

                <div ><span className='info-title'>Exam Type:</span><span className='info-data'> {candidateList?.exam_type === 'THEORY' ? 'SKILLS': <span>{candidateList?.exam_type}</span>}</span></div>
                <div ><span className='info-title'>Questions Count:</span><span className='info-data'> {candidateList?.questions?.length}</span></div>
                {/* <div > <span className='info-title'>Test Status:</span> <span className='info-data'> {candidateList?.test_status}</span></div>  */}
                {/* <div > <span className='info-title'>Test Time:</span> <span className='info-data'> {candidateList?.test_time} Seconds</span></div>  */}
                {/* <div > <span className='info-title'>Test Link:</span> {candidateList?.exam_link && <span className='info-data'> {candidateList?.exam_link}users-test?id={candidateList?.test_id}</span>} </div>  */}
                <div > <span className='info-title'>Test Link:</span> <span className='info-data'> {candidateList?.exam_link}</span> {candidateList?.exam_link && <span> <Button variant="dark" className="copy-button" onClick={handleCopy}>
                  {buttonText}
                </Button></span>}  </div>
              </div>
            </Col>
            <Col>
              <div>
                <div > <span className='info-title'>Create At:</span> <span className='info-data'> {formattedDate}</span></div>
                <div > <span className='info-title'>Questions Generation:</span> <span className='info-data'> {candidateList?.gen_questions_status} <FaCircleCheck className='marg-btm-4 color-green' /></span></div>
                {(candidateList?.exam_status ==='PENDING')&&( <div > <span className='info-title'>Exam Status:</span> <span className='info-data'> {candidateList?.exam_status} <GoXCircleFill className='marg-btm-4 color-red' /> </span></div>)}
                {(candidateList?.exam_status ==='NEW' || candidateList?.exam_status ==='ENDED')&&(<div > <span className='info-title'>Exam Status:</span> <span className='info-data'> {candidateList?.exam_status} <FaCircleCheck className='marg-btm-4 color-green' /> </span></div>)}
                <div > <span className='info-title'>Analysis Status:</span> <span className='info-data'> {candidateList?.gen_analysis_status} <FaCircleCheck className='marg-btm-4 color-green' /> </span></div>
                <div > <span className='info-title'>Overall Score:</span> <span className='info-data'> {candidateList?.overall_avg_score}</span></div>
                <div > <span className='info-title'>Overall Analysis:</span> <span className='info-data'> {candidateList?.overall_analysis}</span></div>
              </div>
            </Col>
          </Row>
        </div>
        {/* )}  */}

        <div className='qns-div-width'>
          <Accordion>
            <Accordion.Header>
              <h5 className='qns-titile'>Questions</h5>
            </Accordion.Header>
            <Accordion.Body>
              <div className='can-btn-div' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right' }}>
                {questionsResponce && <span style={{ flex: 1 }} className='error-resp'> {questionsResponce} </span>}
                {verifyOtp === null && <Button variant='dark' className="Button-add" onClick={generateAgainButton} disabled={questionsLoading} >Generate again </Button>}
              </div>
              {candidateList?.exam_type === 'CODING' ? (<>
                {questionsList?.length > 0 ? (
                <>
                  {questionsList?.map((qns, index) => (
                    <Row key={index} style={{ padding: 10, margin: 1, backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'white' }}>
                      <div className='margin-1'><span className='analysis-key'>Q-</span>{qns?.qid}. {qns.task}</div>                     
                      <pre style={{ whiteSpace: 'pre-wrap',paddingLeft:50 }}>
                        <code>{qns.skeleton_code}</code>
                      </pre>
                      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'left' }}>
                          <div className='button-view-text'>{qns?.q_tech}</div>
                          {/* <div className='button-view-text-time'><span className='analysis-key'>Time: </span>{candidateList?.test_time}sec</div> */}
                        </div>
                    </Row>
                  ))}
                </>
              ) : (<p>No questions available</p>)}
              </>):(<>
                {questionsList?.length > 0 ? (
                <>
                  {questionsList?.map((qns, index) => (
                    <Row key={index} style={{ padding: 10, margin: 1, backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'white' }}>
                      <div className='margin-1'><span className='analysis-key'>Q-</span>{qns?.qid}. {qns.q_text}
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'left' }}>
                          <div className='button-view-text'>{qns?.q_tech}</div>
                          <div className='button-view-text-time'><span className='analysis-key'>Time: </span>{candidateList?.test_time}sec</div>
                        </div>
                      </div>
                    </Row>
                  ))}
                </>
              ) : (<p>No questions available</p>)}
              </>)}

            </Accordion.Body>
          </Accordion>
        </div>


        <div className='qns-div-width'>
          <Accordion>
            <Accordion.Header>
              <h5 className='qns-titile'>Analysis</h5>
            </Accordion.Header>
            <Accordion.Body>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right', marginBottom: 16 }}>
                {reportResponce && <span className='error-resp'> {reportResponce} </span>}{loading && <span> <Spinner /> </span>}

                {verifyOtp === null && <Button variant='dark' className="Button-add-an" onClick={generateAnalysisButton} disabled={loading} >Generate Analysis </Button>}
                {/* <Form.Check type='checkbox' label='With Analysis'
                          checked={isChecked}
                          onChange={() => setIsChecked(!isChecked)}
                          style={{marginTop:5}} className='result-checkbox'
                        />
                        <Button variant='dark' className="Button-add-an" onClick={  downloadAnalysisButton } disabled={loading} >Download Analysis </Button> */}
              </div>
              <div>
                      {/* {audioUrl && (
                        <audio controls style={{ height: 30 }}>
                          <source src={audioUrl} type="audio/mpeg" />
                          Your browser does not support the audio element.
                        </audio>
                      )}  */}
                    </div>
              {candidateList?.exam_type === 'CODING' ? <>
              {analysisList?.length > 0 ? (
                <> {analysisList?.map((qns, index) => (
                  <Row key={index} style={{ paddingTop: 10, paddingBottom: 10, margin: 1, backgroundColor: index % 2 === 0 ? '#e4efe4' : 'white' }}>
                    <p className='margin-1'><span className='analysis-key'>Q-{qns?.qid}. </span><span className='color-red'>{qns?.task}</span> </p>
                    <div className='margin-1'> <span className='analysis-key'>Answer: </span><span className='color-blue'> 
                    <pre style={{ whiteSpace: 'pre-wrap',paddingLeft:50 }}>
                        <code>{qns.q_answer}</code>
                      </pre>
                     </span> </div>
                    <p className='margin-1'> <span className='analysis-key'>Analysis: </span><span className='color-orange'> {qns?.ai_analysis} </span> </p>
                    <Row>
                      <Col>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'left' }}>
                          {/* <div className='button-view-text'>{qns?.q_tech}</div> */}
                          <div className='button-view-text'><span className='analysis-key'>Score: </span> {qns?.score}</div>
                        </div>
                        <div>
                  {/* {qns.audio_url && (
                        <audio controls style={{ height: 30 }}>
                          <source src={qns.audio_url} type="audio/mpeg" />
                          Your browser does not support the audio element.
                        </audio>
                      )}  */}
                      {!qns.downloading && !qns.blobVideoUrl  && qns?.q_answer !== "candidate didn’t answer" && (
            <Button variant='dark' onClick={() => playVideoFromPresignedUrl(qns.video_url, index)}>
            {indexing1 === index && downloading ? (
              <Spinner animation="border" size="sm" role="status" style={{ marginRight: '5px' }} />
            ) : (
              <>
                <FaDownload /> Get Video
              </>
            )}
          </Button>
          
          
          )}
          {qns.blobVideoUrl && !qns.downloading && qns?.q_answer !== "candidate didn’t answer" &&(
        <video controls style={{ width: '180px', height: '100px' }} autoPlay>
            <source src={qns.blobVideoUrl} />
            Your browser does not support the video tag.
        </video>
)}
                      </div> 
                      </Col>
                    </Row>

                  </Row>
                ))}</>
              ) : (<p>No Analysis available</p>)}
              </>:<>
              {analysisList?.length > 0 ? (
  <> 
    {analysisList?.map((qns, index) => (
  <Row key={index} style={{ paddingTop: 10, paddingBottom: 10, margin: 1, backgroundColor: index % 2 === 0 ? '#e4efe4' : 'white' }}>
    <p className='margin-1'><span className='analysis-key'>Q-{qns?.qid}. </span><span className='color-red'>{qns?.q_text}</span> </p>
    <p className='margin-1'> <span className='analysis-key'>Answer: </span><span className='color-blue'> {qns?.q_answer} </span> </p>
    <p className='margin-1'> <span className='analysis-key'>Analysis: </span><span className='color-orange'> {qns?.ai_analysis} </span> </p>
    <Row>
      <Col>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'left' }}>
          {/* <div className='button-view-text'>{qns?.q_tech}</div> */}
          <div className='button-view-text'><span className='analysis-key'>Score: </span> {qns?.score}</div>
        </div>
        <div>
        {error && indexing === index && <p style={{ color: 'red',fontSize:"15px",fontWeight:"bold" }}>{error}</p>}
          {!qns.downloading && !qns.blobAudioUrl && qns?.q_answer !== "candidate didn’t answer" && (
            <Button variant='dark' onClick={() => convertAndPlayAudio(qns.audio_url, index)} style={{marginRight:"15px"}}>
            {indexing === index && downloading ? (
              <Spinner animation="border" size="sm" role="status" style={{ marginRight: '5px' }} />
            ) : (
              <>
                <FaDownload /> Get Audio
              </>
            )}
          </Button>
          
          
          )}
          {!qns.downloading && !qns.blobVideoUrl  && qns?.q_answer !== "candidate didn’t answer" && (
            <Button variant='dark' onClick={() => playVideoFromPresignedUrl(qns.video_url, index)}>
            {indexing1 === index && downloading ? (
              <Spinner animation="border" size="sm" role="status" style={{ marginRight: '5px' }} />
            ) : (
              <>
                <FaDownload /> Get Video
              </>
            )}
          </Button>
          
          
          )}
          {qns.blobVideoUrl && !qns.downloading && qns?.q_answer !== "candidate didn’t answer" &&(
        <video controls style={{ width: '180px', height: '100px' }} autoPlay>
            <source src={qns.blobVideoUrl} />
            Your browser does not support the video tag.
        </video>
)}

          {qns.blobAudioUrl && !qns.downloading && qns?.q_answer !== "candidate didn’t answer" &&(
            <audio controls style={{ height: 30 }} autoPlay>
              <source src={qns.blobAudioUrl} />
              Your browser does not support the audio element.
            </audio>
          )}
        </div>
      </Col>
    </Row>
  </Row>
))}
  </>
) : (
  <p></p>
)}
              </>}

           
            </Accordion.Body>
          </Accordion>


        </div>

      </div>
    )}

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',marginBottom:'20px'  }}>
      {emailSuccess && <div className='success-msg'> {emailSuccess}  </div>}
      { !showPopup && !showOtp && verifyOtp === null && (<div style={{ border: '1px solid #ccc', padding: '5px', borderRadius: '5px', width: '300px', textAlign: 'center' }}>
        <h6>Send Email</h6>
        <Form.Control
          type="email"
          placeholder="Enter Email"
          value={emailInput}
          onChange={handleChange}
          className="placehold-padding"
          style={{ marginBottom: '5px' }}
        />
        <Button
        variant='dark'
          onClick={handleSendMail}
          style={{ padding: '5px 10px',  border: 'none', borderRadius: '3px' }}
        >
          {sendEmail ? (
              <>
                  <Spinner animation="border" size="sm" role="status" style={{ marginRight: '5px' }} />
                  Sending...
              </>
          ) : (
              <>Send</>
          )}
        </Button>
      </div>
      )}

      {( showPopup &&<div style={{ border: '1px solid #ccc', padding: '5px', borderRadius: '5px', width: '300px', textAlign: 'center',marginTop:'20px' }}>
        <h6>Verify OTP</h6>
        <Form.Control
          type="text"
          placeholder="Enter OTP"
          value={otpInput}
          onChange={handleOTPChange}
          className="placehold-padding"
          style={{ marginBottom: '5px' }}
        />
        <Button
        variant='dark'
          onClick={handleOtpVerfication}
          style={{ padding: '5px 10px',  border: 'none', borderRadius: '3px' }}
        >
          {sendEmail ? (
              <>
                  <Spinner animation="border" size="sm" role="status" style={{ marginRight: '5px' }} />
                  Submitting...
              </>
          ) : (
              <>Submit</>
          )}
        </Button>
      </div>
    )}
    </div>

    </div>

  );


}
export default CandidateListsForManager